import * as React from 'react';
import styled from '@emotion/styled';
import { tokens, Alert, Button } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

type Props = {
  hasNextQueryParameter: boolean;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${tokens.spacer.x2};
`;

const Title = styled.h1`
  ${tokens.text('header4')};
  margin-bottom: ${tokens.spacer.x2};
  overflow: initial;
`;

const SubTitle = styled.h2`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};
  margin-bottom: ${tokens.spacer.x6};
`;

const StyledButton = styled(Button)`
  width: 100%;
  justify-content: center;
`;

const StyledAlert = styled(Alert)`
  margin-bottom: ${tokens.spacer.x2};
`;

export const LoginSuccessState = ({ hasNextQueryParameter }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      {hasNextQueryParameter && (
        <StyledAlert kind="success">{t('common:login.form.success-login')}</StyledAlert>
      )}
      <Title>{t('common:login.form.success-title')}</Title>
      <SubTitle>{t('common:login.form.success-subtitle')}</SubTitle>
      <StyledButton data-testid="dashboard-overview-redirect" kind="primary" as="a" href="/">
        {t('common:login.form.success-action')}
      </StyledButton>
    </Container>
  );
};
